import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum ScreenServiceEnum {
  getScreen = ""
}

export default class ScreenService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/screen");
  }

  public getScreen = async (): Promise<any> => await this.GET(ScreenServiceEnum.getScreen);
}



// WEBPACK FOOTER //
// ./src/services/api/Screen.service.ts